<template>
  <div v-if="initialized">
    <div id="app">
      <router-view></router-view>
    </div>

    <b-modal centered v-model="alertshown" class="alertbox" ref="modalalert" id="modalalert" v-bind:hide-footer="true" v-bind:hide-header="true">
      <div class="row">
        <div class="col-12 center">
          <p>{{modaltext}}</p>
        </div>
      </div>
      <div class="row">
        <div class="col-6 center">
          <a href="#" v-on:click.prevent="alertshown = false" class="btn btn-third">{{$t('NO')}}</a>
        </div>
        <div class="col-6 center">
          <a href="#" class="btn btn-secondary" v-on:click.prevent="positiveModalFunc">{{$t('YES')}}</a>
        </div>
      </div>
    </b-modal>

  </div>
  <div v-else-if="!initialized" class="loading-page">
    <icon name="spinner" scale="2" spin></icon>
  </div>
</template>

<script>
import
{
    mapGetters,
    mapActions,
}
from 'vuex';
import globals from '@/api/Globals';

export default
{
    name: 'app',
    data()
    {
        return {
            alertshown: false,
            positivefunc()
            {},
            modaltext: '',
            checkedTrans: [],
        };
    },
    components:
    {

    },
    methods:
    {
        ...mapActions([
            'getGlobals',
            'fetchLanguage',
        ]),
        positiveModalFunc()
        {
            const me = this;
            me.positivefunc();
            me.alertshown = false;
            me.positivefunc = function ()
            {};
        },
    },
    created()
    {
        const me = this;

        me.getGlobals();

        // Rejoin the company room whenever the socket comes back.
        //
        // subscribe was only ever sent from the groupId watcher, which fires
        // once after the globals load. socket.io reconnects on its own after a
        // dropped connection - and with upgrade off and websocket only, that
        // happens - but the room does not survive it. Everything then went on
        // arriving at the server and nothing reached the page, until a refresh
        // ran the watcher again. That is why a light switched elsewhere stayed
        // on screen until reload.
        if (me.socket !== false)
        {
            me.socket.on('connect', () =>
            {
                if (me.globals != null && me.globals.sessionId != null)
                {
                    me.socket.emit('subscribe', me.globals.sessionId);
                }
            });
        }
    },
    watch:
    {
        'globals.groupId'(value)
        {
            const me = this;
            if (value != 0 && value != 2)
            {
                if (me.socket != false)
                {
                    console.log('socket subscribe');
                    me.socket.emit('subscribe', me.globals.sessionId);
                }
                this.$router.push('/dashboard');
            }
            else
            {
                this.$router.push('/login');
            }
        },
        'globals.langId'(value)
        {
            this.fetchLanguage(value);
        },
        socket(value)
        {
            this.fetchLanguage(value);
        },
        translation(value)
        {
            console.log(JSON.stringify(value));
            this.$i18n.setLocaleMessage(`ln${value.key}`, value.root);
            this.$i18n.locale = `ln${value.key}`;
        },
        langInitialized(value)
        {
            const me = this;
            if (value)
            {
                this.$i18n.missing = function (handler, key, vueInst)
                {
                    if (me.checkedTrans.indexOf(key) === -1)
                    {
                        globals.checkTrans(key);
                        me.checkedTrans.push(key);
                    }
                };
            }
        },
        modalAlert(val)
        {
            const me = this;
            me.alertshown = true;
            me.modaltext = val.text;
            me.positivefunc = val.btnAction;
        },
    },
    computed:
    {
        ...mapGetters([
            'globals',
            'socket',
            'modalAlert',
            'translation',
            'langInitialized',
        ]),
        loggedIn()
        {
            return (this.globals.groupId != 2);
        },
        initialized()
        {
            return (this.globals.groupId != 0);
        },
    },
};
</script>
